import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import { ssListItem } from 'app/components/global';
import enterpriseThreatAssessment from './enterpriseThreatAssessment';
import topThreatsByProcess from './topThreatsByProcess';
import controller from './risk-threat-assessment.controller';
import directive from './risk-threat-assessment.directive';


export default angular.module('app.components.advisory.bcp.riskThreatAssessment', [
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
  ssListItem,
  enterpriseThreatAssessment,
  topThreatsByProcess,
])
  .directive('bcpRiskThreatAssessment', directive)
  .controller('RiskThreatAssessmentController', controller)
  .name;

console.log('app.components.advisory.bcp.riskThreatAssessment created');
